var _clipPath, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLargeArrowDown = function SvgLargeArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "large-arrow-down_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    transform: "rotate(90 12 12)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#large-arrow-down_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12 12 22 2 12",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 1v21h-2V1z",
    fill: "var(--native-icon-fill)"
  }))));
};

export default SvgLargeArrowDown;